import { render, staticRenderFns } from "./GP2BrowserAiAssistantPanel.vue?vue&type=template&id=49ddfe5d&scoped=true&"
import script from "./GP2BrowserAiAssistantPanel.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserAiAssistantPanel.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserAiAssistantPanel.vue?vue&type=style&index=0&id=49ddfe5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ddfe5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ddfe5d')) {
      api.createRecord('49ddfe5d', component.options)
    } else {
      api.reload('49ddfe5d', component.options)
    }
    module.hot.accept("./GP2BrowserAiAssistantPanel.vue?vue&type=template&id=49ddfe5d&scoped=true&", function () {
      api.rerender('49ddfe5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserAiAssistantPanel.vue"
export default component.exports